module.exports = __webpack_public_path__ + "assets/holiday.bfa93523.svg";